import React from 'react'
import { Button, Grid, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

import Comps from '@/housefolios-components/PropertyContainer/CenterPage/Comps'
import PropertySummary from '@/housefolios-components/PropertyContainer/CenterPage/summary'
import MarketAnalysis from '@/housefolios-components/PropertyContainer/CenterPage/MarketAnalysis'

import { usePublicProperty } from '@/hooks/usePublicProperty'
import PropertySidebar from '@/housefolios-components/PublicPages/components/PropertySidebar'
import PropertyHeader from '@/housefolios-components/PublicPages/components/PropertyHeader'
import SignupDialog from '@/housefolios-components/PublicPages/components/SignupDialog'

import {
  innerContentLayoutSx,
  innerContentMainSx,
} from '@/layout-blueprints/chromeComponentSx'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

export default function PublicProperty(props) {
  const {
    property,
    compProperties,
    compValues,
    activeTab,
    isSidebarMenuOpen,
    openSignup,
    anchorElMoreOptionsMenu,
    loading,
    toggleSidebarMenu,
    toggleSignup,
    handleClickMoreOptionsMenu,
    handleCloseMoreOptionsMenu,
    toggle,
  } = usePublicProperty()

  const renderCentralPage = (property) => {
    switch (activeTab) {
      case 'Summary':
        return (
          <PropertySummary
            property={property}
            toggleCenter={toggle}
            public
          />
        )
      case 'Comps':
        return (
          <Comps
            property={property}
            toggleCenter={toggle}
            comps={compProperties}
            compValues={compValues}
            public
          />
        )
      case 'MarketAnalysis':
        return (
          <MarketAnalysis
            property={property}
            toggleCenter={toggle}
            analysisInput={property.acquisition.analysis}
            public
          />
        )
      default:
        return null
    }
  }

  if (loading) return <LoadingSkeleton variant="dashboard" />

  return (
    <Box sx={innerContentLayoutSx({ fixed: true })}>
      {/* Mobile menu button */}
      <Box sx={{ px: '1.5rem', order: 0, '@media (min-width: 1100px)': { display: 'none' }, }}>
        <Button
          onClick={toggleSidebarMenu}
          size="small"
         
          sx={{
            boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
            color: "#fff",
            backgroundColor: "#368cff",
            backgroundImage: "none",
            borderColor: "#368cff",
            "&:not(:disabled):hover": { backgroundColor: "#368cff", color: "#fff" },
            "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#036fff" },
            "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(54, 140, 255, 0.4), 0 0.0625rem 0.385rem rgba(54, 140, 255, 0.54)" },
            "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
            "html[data-color-mode=\"dark\"] &": { color: "#fff !important" },
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            border: 0,
            height: "40px !important",
            width: "40px !important",
            lineHeight: "40px !important",
            p: 0,
          }}
        >
          <FontAwesomeIcon icon={['fas', 'ellipsis-vertical']} />
        </Button>
      </Box>

      {/* Sidebar */}
      <PropertySidebar
        isOpen={isSidebarMenuOpen}
        activeTab={activeTab}
        onTabChange={toggle}
      />

      {/* Main content */}
      <Box
        sx={[
          innerContentMainSx,
          { ...{
            border: "1px solid rgba(79, 80, 98, 0.3)",
            boxShadow: "0 0.46875rem 2.1875rem rgba(59, 62, 102, 0.03), 0 0.9375rem 1.40625rem rgba(59, 62, 102, 0.03), 0 0.25rem 0.53125rem rgba(59, 62, 102, 0.05), 0 0.125rem 0.1875rem rgba(59, 62, 102, 0.03)",
            overflow: "visible",
            "& .card-header": { display: "flex", alignItems: "center" },
          }, order: 3, backgroundColor: '#f8f9ff' },
        ]}
      >
        <Box sx={{
          position: "relative",
          height: "100%",
          maxHeight: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
        }}>
          <PropertyHeader
            property={property}
            onMoreOptionsClick={handleClickMoreOptionsMenu}
            anchorEl={anchorElMoreOptionsMenu}
            onCloseMoreOptions={handleCloseMoreOptionsMenu}
          />
          {renderCentralPage(property)}
        </Box>
      </Box>

      {/* Signup dialog */}
      <SignupDialog open={openSignup} onClose={toggleSignup} />
    </Box>
  )
}
